<wiz-hgroup width="100%" height="100%" padding="5px">
  <!-- pavé gauche -->
  <wiz-h-divider width="100%" height="100%" gap="0">
    <!-- panneau gauche -->
    <wiz-group width="450px" minWidth="0px" maxWidth="600px" height="100%" gap="0">
      <wiz-vgroup
        #vgMultiDisplay
        gap="0"
        minWidth="200px"
        width="100%"
        height="100%"
        padding="5px">
        <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
          <wiz-hgroup target="icons">
            <wiz-icon [wizTooltip]="'$.common.export.$'" class="image-purple" (click)="doAct('export')">download</wiz-icon>
            <wiz-icon [wizTooltip]="'$.common.import.$'" class="image-purple" (click)="doAct('import')" >upload</wiz-icon>
          </wiz-hgroup>
          <!-- bouton d'ajout -->
          <wiz-vgroup gap="10" target="title">
            <wiz-dropdown
              #ddStep
              [wizLabel]="'$.step.choose.$'"
              [wizDataProvider]="visionStepsSimulation"
              [wizLabelField]="'levelAndLabel'"
              [manageModel]="false"
            ></wiz-dropdown>
            <!-- <wiz-button #btnAddMeasure height="16px" width="16px" class="round-button" [wizIcon]="'add'"></wiz-button> -->
            <wiz-label
              [wizLabel]="'$.measure.available.$'"
              [wizTextBehavior]="'truncate'"
              width="100%"
              class="smallTitleLabel"
            ></wiz-label>
          </wiz-vgroup>
        </multi-display>
      </wiz-vgroup>

      <canvas #canvasLeft width="344px" height="600" style="pointer-events: none"></canvas>
    </wiz-group>

    <wiz-hgroup width="100%" height="100%">
      <wiz-group width="100%" height="100%" gap="0" [customStaging]="true" style="overflow: auto">
        <canvas #canvas></canvas>
        <ng-container #canvasContainer></ng-container>
        <canvas #canvasDot style="pointer-events: none"></canvas>
      </wiz-group>
    </wiz-hgroup>
  </wiz-h-divider>
</wiz-hgroup>
